import { Role } from "../enums/role";
import { Service } from "../enums/service";
import { RoleMap } from "../models/configuration";

export class Functions {
  static getServiceName(id: number): string {
    switch (id) {
      case Service.AddUsers:
        return 'functions.add';
      case Service.Afib:
        return 'functions.afib';
      case Service.Breath:
        return 'functions.breath';
      case Service.EcgDisplay:
        return 'functions.ecg';
      case Service.Gait:
        return 'functions.gait';
      case Service.Hrv:
        return 'functions.hrv';
      case Service.LongReport:
        return 'functions.report';
      case Service.Posture:
        return 'functions.posture';
      case 42:
        return 'functions.romberg';

      default:
        return `#${id}`;
    }
  }

  static getRoles(): RoleMap[] {
    // Create dropdown filter options from enum
    return Object.keys(Role)
      .filter(key => isNaN(Number(key))) // Keep only string keys
      .map(key => ({
        id: Role[key as keyof typeof Role],
        value: key
      }));
  }

  static   getRoleName(role: number): string {
    const name: string = Role[role as Role];
    return name;
  }

  static   getRoleSeverity(role: number) {
    switch (role) {
      case 1:
      case 2:
        return 'warn';
      case 3:
        return 'info';

      case 4:
        return 'secondary';

      case 5:
        return 'success';

      default:
        return 'danger';
    }
  }

  static getMaxRoleUsable(roles: number[]): number {
    if (roles.length === 0) {
      return Role.patient;
    } else if(roles.includes(Role.superAdmin)) {
      return Role.superAdmin;
    } else if (roles.includes(Role.admin)) {
      return Role.admin;
    } else if (roles.includes(Role.clinician)) {
      return Role.clinician;
    } else {
      return Math.min(...roles);
    }
  }
}
